export const computeMakeURL = ({ value }) => {
    const keyword = value.toLowerCase().split(" ").join("-");
    return [keyword, "cars"];
};
